<script>
    import {onMount} from "svelte";
    import {_} from '../lib/i18n';
    import FreeAccessDataHiddenAlert from "./FreeAccessDataHiddenAlert.svelte";
    import {navigate} from "svelte-routing";

    export let item;
    export let rating;9
    export let analyze;
    let targetId;
    $: analyze && analyze.account && (targetId = Number(analyze.account.instagram_id));

    export let params;

    export let showLikedImages = false;

    let clientWidth;
    let clientHeight;

    export let selectMedia;
    export let showPhotoModal = false;
    export let showVideoModal = false;

    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let isBlur = false;
    $: isBlur = ![2, 4, 6].includes(rating) && params.identity.isEnabledFreeTrial();

    let isEnabledFreeTrial = false;
    $: isEnabledFreeTrial = params.identity.isEnabledFreeTrial();

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }

    function onImageError(event) {
        event.target.src = '/spy20-lk/icons/avatar-empty.svg';
    }

    function onMediaImageError (event) {
        event.target.src = '/spy20-lk/img/image-empty.svg';
    }

    function toggleShowLikedImages() {
        showLikedImages = !showLikedImages;
    }

    function showInModal(item, index) {
        if (isEnabledFreeTrial && ![1, 3, 5].includes(index + 1)) {
            gotoTariffs();
            return;
        }
        try {
            selectMedia(item);

            showPhotoModal = false;
            showVideoModal = false;

            if (item.video) {
                showVideoModal = true;
            } else {
                showPhotoModal = true;
            }
        } catch (err) { console.error(err) }
    }

    let showMediasCounter = 8;
    let showShowMoreMedias = item ? ((item.to.length + item.from.length) > showMediasCounter) : true;

    onMount(() => {
        showMediasCounter = (clientWidth >= 425) ? 10 : 8;
    });


    let medias = [];
    $: (item || showMediasCounter) && filterMedias();

    function filterMedias() {
        medias = [...item.to];
        medias = medias.concat(item.from);
        medias.sort((a, b) => {
            if ( Number(a.created_at) < Number(b.created_at) ){
                return 1;
            }
            if ( Number(a.created_at) > Number(b.created_at) ){
                return -1;
            }
            return 0;
        });
        medias = medias.splice(0, showMediasCounter);
    }

    function showMoreMedias() {
        showMediasCounter += (clientWidth >= 425) ? 10 : 8;
        if (showMediasCounter > (item.to.length + item.from.length)) {
            showMediasCounter = (item.to.length + item.from.length);
            showShowMoreMedias = false;
        }
    }
</script>



<div class={`feed-item feed-item_like ${showLikedImages ? 'open' : ''}`} bind:clientWidth={clientWidth} bind:clientHeight={clientHeight}>
    <div class="feed-item__header" on:click={toggleShowLikedImages}>
        <div class="feed-item__rating">{rating}</div>
        <div class="feed-item__header-wrapper">
            <img src={item.account.photo} alt="" class="feed-item__avatar {isBlur ? 'blur-content' : ''}" on:error={onImageError}  />
            <div class="feed-item__info-wrapper">
                {#if isBlur}
                    <p class="feed-item__name" on:click={gotoTariffs}>
                        @{$_('likesResult.someone')}
                    </p>
                {:else}
                    <a href={`https://instagram.com/${item.account.username}`} class="feed-item__name" target="_blank">
                        @{item.account.username}
                    </a>
                {/if}
                <div class="feed-item__stats-wrapper" >
                    <div class="feed-item__stats-item">
                        <div class="feed-item__stats-label">
                            <div class="feed-item__stats-icon feed-item__stats-icon_give">
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.8285 6.82847L1.17165 1.17161M1.17165 1.17161L5.41429 1.17161M1.17165 1.17161L1.17165 5.41425" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <p class="feed-item__stats-title">{$_('likesResult.likeTo')}</p>
                        </div>
                        <p class="feed-item__stats-number">{isBlur ? 'XXX' : item.to.length}</p>
                    </div>
                    <div class="feed-item__stats-item">
                        <div class="feed-item__stats-label">
                            <div class="feed-item__stats-icon feed-item__stats-icon_get">
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.1715 1.17153L6.82835 6.82839M6.82835 6.82839L2.58571 6.82839M6.82835 6.82839L6.82835 2.58575" stroke="#1B62A4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <p class="feed-item__stats-title">{$_('likesResult.likeFrom')}</p>
                        </div>
                        <p class="feed-item__stats-number">{isBlur ? 'XXX' : item.from.length}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="feed-item__more-btn" >
            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.25 1.34998L6.70711 5.89287C6.31658 6.28339 5.68342 6.28339 5.29289 5.89287L0.75 1.34997" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
    </div>
    {#if showLikedImages && !isBlur}
        <div class="feed-item__body" >
            <div class="feed-item__content-wrapper">
                {#each medias as item, index}
                    <div class="feed-item-like-content">
                        <div class={`feed-item-like-content__flag feed-item-like-content__flag_${targetId === Number(item.media_owner_id) ? 'give' : 'get'}`}>
                            {#if targetId === Number(item.media_owner_id)}
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.8285 6.82847L1.17165 1.17161M1.17165 1.17161L5.41429 1.17161M1.17165 1.17161L1.17165 5.41425" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            {:else}
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.1715 1.17153L6.82835 6.82839M6.82835 6.82839L2.58571 6.82839M6.82835 6.82839L6.82835 2.58575" stroke="#1B62A4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            {/if}
                        </div>
                        <div class="feed-item-like-content__img-wrapper" on:click={() => showInModal(item, index)}>
                            <img src={item.image} alt="" class="feed-item-like-content__image {(![1, 3, 5].includes(index + 1) && isEnabledFreeTrial) ? 'blur-content' : ''}" on:error={onMediaImageError} />
                        </div>
                    </div>
                {/each}
            </div>
            {#if showShowMoreMedias}
                <button class="button button_textual feed-item__load-btn" on:click={showMoreMedias}>
                    {$_('likesResult.showMore')}
                </button>
            {/if}
        </div>
    {:else if (showLikedImages && isBlur)}
        <FreeAccessDataHiddenAlert {params} />
    {/if}
</div>

<style>
    .feed-item__avatar {
        border-radius: 100%;
    }
    .feed-item-like-content__image {
        max-width: 100%;
    }
    .blur-content {
        -webkit-filter: blur(10px);
        filter: blur(10px);
    }
</style>